<template>
  <vx-card>
    <!-- COVER PHOTO-->
    <div slot="no-body" class="card-cover cursor-pointer pointer-events-auto"
         @click="handlerToClassOverviewClick">
      <img :src="classRoomPhoto"
           alt="content-img" class="responsive card-img-top">
    </div>

    <!-- SUBJECT NAME & PERIOD CODE-->
    <div class="flex justify-between center mb-2">
      <h5 v-line-clamp="2">
        <a class="text-dark cursor-pointer" @click="handlerToClassOverviewClick">
          {{ studentEnrollDetail.subject.nameLocal }}
        </a>
      </h5>

      <vs-chip transparent color="primary" class="ml-2">
        {{ studentEnroll.periodCode }}
      </vs-chip>
    </div>

    <!-- SUBJECT CODE & SECTION NO & LEARN SPAN NO-->
    <div class="flex justify-between flex-wrap center mb-1">
      <p class="text-grey">{{ studentEnrollDetail.subject.code }}</p>

      <p class="text-grey">
        {{$t('class-overview.section')}} {{ studentEnrollDetail.classSection.sectionNo }}
        {{$t('class-overview.span')}} {{ studentEnrollDetail.classSection.learnSpanNo }}
      </p>
    </div>

    <!-- TEACHER-->
    <div class="flex justify-start flex-wrap items-center text-left my-2">
      <vs-avatar :src="teacherProfile" class="ml-0 my-0" size="24px"/>
      <p class="text-grey mx-1"> {{$t('home.teach-by')}} </p>
      <p>
        {{ studentEnrollDetail.courseOutlineRegistration.teacher | personName }}
      </p>
    </div>

    <!-- LEARN TIME-->
    <template v-if="showLearnTimeBar">
      <div class="flex justify-between flex-wrap">
      <span class="flex items-center">
              {{ totalClassLearnTimeFormat }}
            </span>
        <div class="flex justify-between">
                <span class="flex items-center text-grey mr-2">
                  {{ totalClassTimeFormat }}
                </span>
          <feather-icon class="text-grey cursor-pointer" icon="ClockIcon" svgClasses="stroke-current h-4 w-4"/>
        </div>
      </div>

      <vs-progress
        :color="progressColor"
        :percent="learnPercent"
        class="block mt-3 mb-2 shadow-md">
      </vs-progress>
    </template>

    <!--ACTION BUTTON-->
    <div class="flex justify-between flex-wrap center mt-4 ">
      <vs-button
        class="mr-2 shadow-lg card-button"
        color="#7367F0"
        gradient-color-secondary="#CE9FFC" type="gradient" @click.stop="handlerToLearningClick"
      >
        <span>{{ $t('home.start-learn') }}</span>
      </vs-button>
      <div class="flex flex-wrap center">
                <span class="flex mr-3"
                      @click.stop="navigateToPM">
                <feather-icon class="cursor-pointer"
                              icon="MessageSquareIcon"
                              svgClasses="text-primary stroke-current h-6 w-6"/>
                <span class="ml-2 mt-3">PM</span>
              </span>
      </div>
    </div>
  </vx-card>
</template>

<script>
import { formatSecondToHHMMSS } from "@/utils/format";
import {getAvatarUrl, getClassRoomUrl} from "@/utils/upload";

export default {
  name: "ClassRoomCard",
  props:[
    'studentEnroll',
    'studentEnrollDetail',
    'showLearnTime'
  ],
  data() {
    return {
      loading: true,
      studentEnrollDetails: [],
      infoTopics: [],
      student: null,
    }
  },
  computed:{
    teacherProfile() {
      return getAvatarUrl(this.studentEnrollDetail.courseOutlineRegistration.teacher ? this.studentEnrollDetail.courseOutlineRegistration.teacher.picturePath : '');
    },
    classRoomPhoto() {
      return getClassRoomUrl(this.studentEnrollDetail.courseOutlineRegistration.courseOutline.picturePath);
    },
    totalClassLearnTimeFormat(){
      return formatSecondToHHMMSS(this.totalClassLearnTime)
    },
    totalClassTimeFormat(){
      return formatSecondToHHMMSS(this.totalClassTime)
    },
    progressColor() {
      let percent = this.learnPercent;
      if (percent >= 100) {
        return 'success';
      }
      return 'primary'
    },
    studentUnitLearnToCountTime(){
      //dont count unit live class
      return this.studentEnrollDetail.studentUnitLearns.filter(item => {
        return item.courseOutlineUnit.countLearnPercent;
      });
    },
    learnPercent() {
      let studentEnrollDetail = this.studentEnrollDetail;
      let percent = 0;

      if (studentEnrollDetail
        && studentEnrollDetail.classSection
        && studentEnrollDetail.classSection.vdoSet
        && studentEnrollDetail.studentUnitLearns
        && studentEnrollDetail.studentUnitLearns.length > 0) {

        const totalLearnTime = this.totalClassLearnTime;
        const totalClassVdoTime = this.totalClassTime;

        percent = (totalLearnTime / totalClassVdoTime) * 100;
        if (percent > 100) {
          percent = 100;
        }
      }

      return percent;
    },
    totalClassLearnTime() {
      let studentEnrollDetail = this.studentEnrollDetail;
      let totalClassLearnTime = 0;
      if (studentEnrollDetail
        && studentEnrollDetail.studentUnitLearns
        && studentEnrollDetail.studentUnitLearns.length > 0) {

        let vdoSetUnitToCount = studentEnrollDetail.classSection.vdoSet.vdoSetUnits.filter(item => {
          return item.courseOutlineUnit.countLearnPercent && item.status === 'enable';
        });
        let unitToCount = this.studentUnitLearnToCountTime;
        // totalClassLearnTime = unitToCount.reduce((total, x) => {
        //   return x.totalLearnTime + total
        // }, 0);
        for(let i = 0; i < vdoSetUnitToCount.length; i++){
          let vdoSetUnit = vdoSetUnitToCount[i];
          let studentUnitLearn = unitToCount.find(e =>
            e.courseOutlineUnit.id === vdoSetUnit.courseOutlineUnit.id &&
            e.vdoSetUnit.id === vdoSetUnit.id)
          if(studentUnitLearn){
            totalClassLearnTime += studentUnitLearn.totalLearnTime
          }
        }

        let totalClassTime = this.totalClassTime;
        if (totalClassLearnTime > totalClassTime) {
          totalClassLearnTime = totalClassTime
        }

      }
      return totalClassLearnTime;
    },
    totalClassTime() {
      let studentEnrollDetail = this.studentEnrollDetail;
      let totalClassTime = 0;
      if (studentEnrollDetail
        && studentEnrollDetail.classSection
        && studentEnrollDetail.classSection.vdoSet) {

        let vdoSetUnitToCount = studentEnrollDetail.classSection.vdoSet.vdoSetUnits.filter(item => {
          return item.courseOutlineUnit.countLearnPercent && item.status === 'enable';
        });

        totalClassTime = vdoSetUnitToCount.reduce((total, x) => {
          return x.totalVdoLength + total
        }, 0);
      }

      return totalClassTime;
    },
    showLearnTimeBar() {
      return this.showLearnTime
    }
  },
  methods:{
    handlerToClassOverviewClick() {
      this.$router.push(`/e-learning/class-overview/${this.studentEnrollDetail.id}`);
    },
    handlerToLearningClick() {
      this.$router.push(`/e-learning/virtual-class/${this.studentEnrollDetail.id}`);
    },
    navigateToPM() {
      this.$router.push(`/pm`);
    },
  }
}
</script>

<style scoped>

</style>
